"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.toggleMultiple = exports.toggleSingle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _BaseSelectModule = _interopRequireDefault(require("./BaseSelect.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var toggleSingle = function toggleSingle(state, newSelection) {
  return [newSelection];
};

exports.toggleSingle = toggleSingle;

var toggleMultiple = function toggleMultiple(state, newSelection) {
  return state.selectedIndexes.includes(newSelection) ? state.selectedIndexes.filter(function (index) {
    return index !== newSelection;
  }) : _toConsumableArray(state.selectedIndexes).concat([newSelection]);
};

exports.toggleMultiple = toggleMultiple;

var BaseSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(BaseSelect, _Component);

  function BaseSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BaseSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BaseSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selectedIndexes: _this.props.defaultSelectedIndexes
    };

    _this.onClick = function (selectedIndex) {
      var _this$props = _this.props,
          stateReducer = _this$props.stateReducer,
          onSelect = _this$props.onSelect;

      _this.setState(function (state) {
        return {
          selectedIndexes: stateReducer(state, selectedIndex)
        };
      }, function () {
        return onSelect(selectedIndex, _this.state);
      });
    };

    return _this;
  }

  _createClass(BaseSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          selectedClassName = _this$props2.selectedClassName,
          disabledClassName = _this$props2.disabledClassName,
          options = _this$props2.options,
          disabledIndexes = _this$props2.disabledIndexes,
          fluid = _this$props2.fluid,
          SelectItem = _this$props2.as,
          passSelectionIndexToItem = _this$props2.passSelectionIndexToItem,
          defaultSelectedIndexes = _this$props2.defaultSelectedIndexes,
          onSelect = _this$props2.onSelect,
          stateReducer = _this$props2.stateReducer,
          rest = _objectWithoutProperties(_this$props2, ["className", "selectedClassName", "disabledClassName", "options", "disabledIndexes", "fluid", "as", "passSelectionIndexToItem", "defaultSelectedIndexes", "onSelect", "stateReducer"]);

      var selectedIndexes = this.state.selectedIndexes;
      return options.map(function (option) {
        var _cx;

        var content = option.content || option;
        var index = option.index || option;
        var isDisabled = disabledIndexes.includes(index);

        if (passSelectionIndexToItem) {
          rest.selectionIndex = index;
        }

        return _react.default.createElement(SelectItem, _extends({}, rest, {
          key: index,
          className: (0, _classnames.default)((_cx = {}, _defineProperty(_cx, "".concat(_BaseSelectModule.default.wrapper, " ").concat(className), true), _defineProperty(_cx, selectedClassName, selectedIndexes.includes(index)), _defineProperty(_cx, disabledClassName, isDisabled), _defineProperty(_cx, _BaseSelectModule.default.fluid, fluid), _cx)),
          onClick: isDisabled ? undefined : function () {
            return _this2.onClick(index);
          }
        }), content);
      });
    }
  }]);

  return BaseSelect;
}(_react.Component);

BaseSelect.defaultProps = {
  defaultSelectedIndexes: [],
  disabledIndexes: [],
  onSelect: function onSelect() {},
  as: 'div',
  fluid: false,
  passSelectionIndexToItem: false
};
process.env.NODE_ENV !== "production" ? BaseSelect.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    index: _propTypes.default.any.isRequired,
    content: _propTypes.default.any.isRequired
  })])).isRequired,
  className: _propTypes.default.string.isRequired,
  selectedClassName: _propTypes.default.string.isRequired,
  disabledClassName: _propTypes.default.string.isRequired,
  defaultSelectedIndexes: _propTypes.default.arrayOf(_propTypes.default.any.isRequired),
  disabledIndexes: _propTypes.default.arrayOf(_propTypes.default.any.isRequired),
  onSelect: _propTypes.default.func,
  stateReducer: _propTypes.default.func.isRequired,
  as: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  fluid: _propTypes.default.bool,
  passSelectionIndexToItem: _propTypes.default.bool
} : void 0;
var _default = BaseSelect;
exports.default = _default;